(() => {
  const PRODUCT_REVIEW_COUNTS = window.MM_PRODUCT_REVIEW_COUNTS || {};

  const selectors = '.rating-count, .jdgm-prev-badge__text, .jm-review-widget p.jm-text';
  const numberPattern = /\d[\d,.]*/g;

  function updateCount(element, count) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    for (let index = textNodes.length - 1; index >= 0; index -= 1) {
      const node = textNodes[index];
      const matches = Array.from(node.textContent.matchAll(numberPattern));
      if (!matches.length) continue;

      const match = matches[matches.length - 1];
      // Already showing this count — bail out so the MutationObserver can't loop.
      if (match[0].replace(/\D/g, '') === String(count)) return;

      // Fixed locale: separators like "1 284" (fr) or "1’284" (de-CH) aren't matched by
      // numberPattern, so each pass would prepend another "1" forever.
      const replacement = count.toLocaleString('en-US');
      const text = node.textContent;
      const updated =
        text.slice(0, match.index) + replacement + text.slice(match.index + match[0].length);

      if (updated !== text) node.textContent = updated;
      return;
    }
  }

  function applyOverrides() {
    document.querySelectorAll(selectors).forEach((element) => {
      if (
        element.matches('.jm-review-widget p.jm-text') &&
        !/\breviews?\b/i.test(element.textContent)
      ) {
        return;
      }

      const productId =
        element.dataset.productId ||
        element.closest('[data-product-id]')?.dataset.productId ||
        element.closest('.jdgm-widget[data-id]')?.dataset.id ||
        (element.closest('.jm-review-widget')
          ? document.querySelector('.jdgm-widget[data-id]')?.dataset.id
          : '');
      if (!productId || !Object.prototype.hasOwnProperty.call(PRODUCT_REVIEW_COUNTS, productId)) {
        return;
      }

      const count = PRODUCT_REVIEW_COUNTS[productId];
      if (!Number.isSafeInteger(count) || count < 0) return;

      updateCount(element, count);
    });
  }

  let scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyOverrides();
    });
  }

  applyOverrides();
  new MutationObserver(scheduleApply).observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
  });
})();
